import { useEffect } from 'react'
import { extractVoiceValue } from '../utils/speechToNumber'
import { useVoiceInput } from '../hooks/useVoiceInput'
import MicButton from './MicButton'

export default function VoiceInputField({
  label,
  unit,
  value,
  onChange,
  type = 'text',
  placeholder = '',
  hint = '',
}) {
  const { transcript, isListening, error, supported, start, stop } = useVoiceInput()

  useEffect(() => {
    if (isListening) return
    if (!transcript.trim()) return
    const parsed = extractVoiceValue(transcript)
    if (parsed !== null) onChange(parsed)
  }, [isListening, transcript, onChange])

  return (
    <div className="rounded-2xl bg-white p-3 shadow-md">
      <label className="mb-1 block text-xl font-bold text-navy-900">
        {label}
        {unit && <span className="ml-2 text-lg font-normal text-gray-500">{unit}</span>}
      </label>
      <div className="flex items-center gap-2">
        <input
          type={type}
          value={value ?? ''}
          inputMode={type === 'text' ? 'text' : 'decimal'}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className="h-14 w-full rounded-xl border-2 border-navy-700 bg-white px-3 text-2xl font-bold text-navy-900 focus:border-warn focus:outline-none"
        />
        <MicButton isListening={isListening} supported={supported} onClick={isListening ? stop : start} />
      </div>
      {isListening && (
        <p className="mt-1 text-lg font-bold text-warn">🎙️ 聆聽中…{transcript ? `「${transcript}」` : ''}</p>
      )}
      {!isListening && transcript && (
        <p className="mt-1 text-lg font-bold text-safe">已填入：{extractVoiceValue(transcript)}</p>
      )}
      {error && <p className="mt-1 text-lg font-bold text-warn">⚠️ {error}</p>}
      {hint && !isListening && !error && (
        <p className="mt-1 text-lg text-gray-500">{hint}</p>
      )}
    </div>
  )
}
